var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaterTreatmentPlant(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 50,
    viewBox: "0 0 44 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2679_764)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.0118 22.1045C43.0118 28.5106 41.416 32.819 35.1481 38.5762C35.0308 38.6857 21.838 49.9114 21.838 49.9114C21.838 49.9114 8.58982 38.4954 8.47247 38.3859C3.67948 34.1712 0.671875 28.5106 0.671875 22.1045C0.671875 10.4108 10.152 0.938477 21.838 0.938477C33.5317 0.938477 43.0118 10.4108 43.0118 22.1045Z",
    fill: "#353535"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9177 38.8076C31.2298 38.8076 38.7788 31.2586 38.7788 21.9465C38.7788 12.6344 31.2298 5.08545 21.9177 5.08545C12.6056 5.08545 5.05664 12.6344 5.05664 21.9465C5.05664 31.2586 12.6056 38.8076 21.9177 38.8076Z",
    fill: "#5CDAF7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8154 20.069C17.3235 18.3815 18.6482 17.0661 20.3416 16.5719V8.61768C14.3381 9.3061 9.57885 14.0655 8.89062 20.069H16.8154Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3418 16.5984C24.9946 17.1118 26.2832 18.4101 26.7827 20.069H34.7927C34.1045 14.0655 29.3452 9.30615 23.3418 8.61768V16.5984Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3416 26.5651C18.6484 26.0709 17.324 24.7559 16.8157 23.0688H8.89062C9.57934 29.0718 14.3386 33.8309 20.3416 34.5193V26.5651Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7825 23.0688C26.2827 24.7274 24.9944 26.0252 23.3418 26.5386V34.5193C29.3447 33.8308 34.104 29.0718 34.7925 23.0688H26.7825Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2679_764"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42.3399,
    height: 48.9729,
    fill: "white",
    transform: "translate(0.671875 0.938477)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaterTreatmentPlant);
export default __webpack_public_path__ + "static/media/water-treatment-plant.41f82a3bc579eea959d121966125de25.svg";
export { ForwardRef as ReactComponent };